import {Component} from 'react';
import h from 'react-hyperscript';
import {h2, p} from 'Components/Typography/Typography';
import content from 'Assets/data/globals.json';

class CountryError extends Component {
  render() {
    return (
      h('div', {
        className: 'error-message error-message--full',
      },
      h('div', null, [
        h(h2, {
          key: 'permissions-error',
          className: 'text--grey text--center permissions-error__title',
        }, content.errors.country.title),
        h(p, {
          key: 'permissions-error-desc',
          className: 'text--grey text--center permissions-error__desc',
        }, [
          content.errors.country.desc.partOne,
          h('a', {
            href: content.errors.country.desc.partTwo.href,
            alt: content.errors.country.desc.partTwo.alt,
            target: '_blank',
          }, content.errors.country.desc.partTwo.text),
          content.errors.country.desc.partThree,
        ]),
      ])
      )
    );
  }
}

export default CountryError;
